var map = {
	"./LogoBlack.png": "3287",
	"./LogoWhite.png": "5f960",
	"./avatar.jpg": "915e",
	"./bg.jpg": "86d5",
	"./characters/1.png": "7320",
	"./characters/10.png": "6f32",
	"./characters/2.png": "91cc",
	"./characters/3.png": "21e1",
	"./characters/4.png": "3eb0",
	"./characters/5.png": "37ca",
	"./characters/6.png": "196e",
	"./characters/7.png": "ce59",
	"./characters/8.png": "8f8b",
	"./characters/9.png": "88dc",
	"./error1.png": "90e4",
	"./event-1.jpg": "f200",
	"./fonts/steelfish bd.woff": "3866",
	"./fonts/steelfish outline.woff": "1068",
	"./fonts/steelfish.woff": "d510",
	"./fortnite.jpg": "4633",
	"./logo — копия (2).png": "bf98",
	"./logo — копия.jpg": "c041",
	"./logo — копия.png": "2b07",
	"./logo.jpg": "b640",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./pl.jpg": "f5ea",
	"./prize-1.jpg": "4529",
	"./prize-2.jpg": "7edd",
	"./prize-3.jpg": "2a25",
	"./prize-4.jpg": "95fc",
	"./vk.png": "b73a",
	"./vk.svg": "330c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";